import { render, staticRenderFns } from "./complaintList.vue?vue&type=template&id=9aa1f3fc&scoped=true"
import script from "./complaintList.vue?vue&type=script&lang=js"
export * from "./complaintList.vue?vue&type=script&lang=js"
import style0 from "./complaintList.vue?vue&type=style&index=0&id=9aa1f3fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa1f3fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9aa1f3fc')) {
      api.createRecord('9aa1f3fc', component.options)
    } else {
      api.reload('9aa1f3fc', component.options)
    }
    module.hot.accept("./complaintList.vue?vue&type=template&id=9aa1f3fc&scoped=true", function () {
      api.rerender('9aa1f3fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/complaintList.vue"
export default component.exports